<template>
  <div :class="className" class="com-btn pointer white flex items-center justify-center">
    <slot name="prefix"/>
    {{ label }}
    <slot name="suffix"/>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '按钮'
    },
    className: {
      type: String,
      default: ''
    },
  },
}
</script>

<style lang="less" scoped>
  @btnColor: #D8271C;
  @btnHeight: .5rem;
  .com-btn {
    background: @btnColor;
    min-width: 1.15rem;
    padding: 0 .25rem;
    height: @btnHeight;
    border-radius: @btnHeight;
    font-size: 14px;
    user-select: none;

    .com-btn_prefix{ 
      font-size: 20px;
      margin-right: .08rem;
    }

    .com-btn_suffix{
      margin-left: 4px;
    }
  }
</style>